import React, { useState } from 'react';
import { localize } from 'core/localization';
import { LINK } from 'constants/components';
import { EULA_PDF_LINK } from 'constants/common';
import PdfDocument from 'components/common/embeddables/PdfDocument';
import { LearnerAgreementText, EulaLinkText } from './LearnerAgreements.styled';

type LearnerAgreementsProps = {
  isSignUpPage?: boolean;
  saveCrossDevice?: boolean;
  loginViaSocialMediaEnabled?: boolean;
  allowToSkipTrackingAndTracingEnabled?: boolean;
};

export const LearnerAgreements = (props: LearnerAgreementsProps) => {
  const [shouldDisplayAgreement, setShouldDisplayAgreement] = useState(false);
  const { isSignUpPage = false } = props;

  const onClick = () => {
    setShouldDisplayAgreement(!shouldDisplayAgreement);
  };

  return (
    <React.Fragment>
      {isSignUpPage && (
        <LearnerAgreementText>{localize('[learner agreement signup]')}{' '} </LearnerAgreementText>
      )}
      <EulaLinkText
        text={localize('[eula]')}
        onClick={onClick}
        opacity={0.7}
        layout={LINK.LAYOUT.FORM}
        href={EULA_PDF_LINK}
      />
      {shouldDisplayAgreement && (
        <PdfDocument url={EULA_PDF_LINK} toggle={setShouldDisplayAgreement} />
      )}
    </React.Fragment>
  );
};

export default LearnerAgreements;
